import {useContext} from 'react'
import {SupplierReportContext} from '../../context'
import Search from '../../../../components/Search'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import MultipleSelect from '../../../../components/MultiSelect/MultiSelect'
import ExportCSVButton from '../../components/ExportCSVButton'
import {isEmpty} from '../../../../utils/common'
import { MIN_DATE_RANGE } from '../../utils'

const SupplierReportHeader = () => {
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {
    onSearch,
    onDateChange,
    suppliers,
    isSuppliersLoading,
    onChangeSupplierFilter,
    onDownloadCSV,
    reportData,
    isLoading,
  } = useContext(SupplierReportContext)

  const handleDateChange = (startDate: any, endDate: any) => {
    onDateChange && onDateChange(startDate, endDate)
  }

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-end mb-10'>
      <div className='d-flex gap-10 align-items-end'>
        <Search
          onSearch={(searchTerm: string) => {
            onSearch && onSearch(searchTerm)
          }}
        />
        <MultipleSelect
          id={`supplier-filter`}
          label='Supplier'
          options={suppliers}
          className='w-200px'
          placeholder='Select Supplier'
          allValuesSelectedText={'Supplier: All'}
          isLoading={isSuppliersLoading}
          handleSelected={onChangeSupplierFilter}
        />
      </div>
      <div className='d-flex gap-5 align-itens-end'>
        <ExportCSVButton
          onExportCSV={onDownloadCSV}
          isLoading={isLoading}
          hide={isEmpty(reportData)}
        />

        <div className='w-250px'>
          <PredefinedDateRange
            cb={handleDateChange}
            getLbl={() => {}}
            defaultValue={dateRangeLabel || 'Last 90 Days'}
            includeCurrantDay={true}
            startDate={MIN_DATE_RANGE}
          />
        </div>
      </div>
    </div>
  )
}

export default SupplierReportHeader
